import React, { useState, useContext } from 'react'
import { useIntl } from 'react-intl'
import { Checkbox } from 'antd'
import { CheckboxChangeEvent } from 'antd/lib/checkbox'
import { DeleteOutlined } from '@ant-design/icons'

import { EditorSettingsContext } from '../../EditorSettingsContext'
import { FlexRow } from '../../../FlexboxReusables/FlexItems'
import Modal from '../../../Modal/Modal'
import { Course } from '../../../Course/types'
import { FormattedMessage } from 'react-intl'
import styled from 'styled-components'
import { IndentedOption } from './utils'

type SettingsProps = {
  course: Course
  deleteCourse: (id: number) => void
}

const EditorSettingsOption = ({ course, deleteCourse }: SettingsProps) => {
  const intl = useIntl()
  const { editorSettingsContext, updateEditorSettingsContext } = useContext(EditorSettingsContext)
  const [ showModal, setShowModal ] = useState(false)

  const handleConfirmDelete = () => {
    deleteCourse(course.id)
    setShowModal(false)
  }

  type EditorSettingKey = keyof typeof editorSettingsContext
  const mutuallyExclusiveSettings: Record<EditorSettingKey, EditorSettingKey> = {
    addNewPagesAtTheEnd: 'addNewPagesAfterCurrentPage',
    addNewPagesAfterCurrentPage: 'addNewPagesAtTheEnd',
  }
  
  const menuItems = Object.entries(editorSettingsContext).map(([ key, value ]) => {
    const onChange = (e: CheckboxChangeEvent) => {
      const updatedContext = { ...editorSettingsContext }

      if (mutuallyExclusiveSettings[key]) {
        updatedContext[mutuallyExclusiveSettings[key]] = !e.target.checked
      }

      updatedContext[key] = e.target.checked
      updateEditorSettingsContext(updatedContext)
    }

    return (
      <FlexRow key={key} margin='0.2em 0'>
        <Checkbox checked={value} onChange={onChange}>
          <FormattedMessage id={`editor.settings.${key}`} />
        </Checkbox>
      </FlexRow>
    )
  })

  return (
    <>
      <Modal
        title={intl.formatMessage({ id: 'editor.settings.deleteDraft' }) + '?'}
        open={showModal}
        onOk={handleConfirmDelete}
        onCancel={() => setShowModal(false)}
        message={<FormattedMessage id="editor.settings.areYouSureYouWantToDelete" />}
      />
      <IndentedOption>
        {menuItems}
        <FlexRow
          justifyContent='flex-start'
          onClick={() => setShowModal(true)}
          style={{ cursor: 'pointer', margin: '0.2em 0' }}
        >
          <IconWrapper>
            <DeleteOutlined style={{ color: 'red' }} />
          </IconWrapper>
          <FormattedMessage id="editor.settings.deleteDraft" />
        </FlexRow>
      </IndentedOption>
    </>
  )
}

export default EditorSettingsOption

const IconWrapper = styled.div`
  margin-right: 0.5em;
`
